Vue.component('credits-services', require('../components/home_host/credits_services.vue').default);
